import { render, staticRenderFns } from "./complaintConfirm.vue?vue&type=template&id=64f33a7f&scoped=true&"
import script from "./complaintConfirm.vue?vue&type=script&lang=js&"
export * from "./complaintConfirm.vue?vue&type=script&lang=js&"
import style0 from "./complaintConfirm.vue?vue&type=style&index=0&id=64f33a7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f33a7f",
  null
  
)

export default component.exports